export const API_BYPASS_ERROR_HANDLER_HEADER_NAME =
    'x-wdx-fe-bypass-global-error-handler';

export enum API_BYPASS_ERROR_HANDLER_HEADER_VALUES {
    All = '.*',
    NotFound404 = '404',
}
